import React, { useCallback, useEffect, useState } from 'react'
import SearshFilter from '../components/shared/SearshFilter'
import showAllContactUsForms from '../apis/showAllContactUsForms'
import ContactTable from '../components/contact/ContactTable'

const ContactUsForms = () => {
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  const fetchData = useCallback(async () => {
    try {
      const contactData = await showAllContactUsForms()

      // Sort by creationDate
      const sortedData = contactData.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      )

      setData(sortedData)
      setFilteredData(sortedData)
    } catch (error) {
      console.error('Failed to fetch', error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  useEffect(() => {
    let filtered = [...data]

    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.message.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }
    setFilteredData(filtered)
  }, [searchTerm, data])

  return (
    <>
      <div className="text-2xl text-darkBlue mb-4">Contact Us Forms</div>
      <SearshFilter
        type="contact"
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortType="creationDate"
        setSortType={() => {}}
      />

      <div className="">
        {loading ? (
          <div>loading ... </div>
        ) : (
          <ContactTable data={filteredData} />
        )}
      </div>
    </>
  )
}

export default ContactUsForms
